/* unplugin-vue-components disabled */import { render } from "./routelist.vue?vue&type=template&id=24c35d5d&scoped=true"
import script from "./routelist.vue?vue&type=script&lang=js"
export * from "./routelist.vue?vue&type=script&lang=js"

import "./routelist.vue?vue&type=style&index=0&id=24c35d5d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c35d5d"]])

export default __exports__